export default "__VITE_ASSET__CEWA2086__"